import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    EventEmitter,
    Input,
    OnInit,
    Optional,
    Output,
    Self,
    ViewEncapsulation
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { TgInput } from '@trademe/tangram';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import {
    ACCEPTED_PHOTO_TYPES,
    MAX_FILE_SIZE,
    MIN_PHOTO_DIMENSION,
    MIN_AGENT_PHOTO_DIMENSION,
    PHOTO_LOAD_TIMEOUT
} from '../constants/photo.constants';
import { ValidatedPhoto } from '../models/validated-photo';
import { PhotoValidationService } from '../services/validation/photo-validation.service';

@Component({
    selector: 'tm-list-photo-picker',
    templateUrl: './photo-picker.component.html',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PhotoPickerComponent extends TgInput<never> implements OnInit {
    @Output() public photosUploaded: EventEmitter<ValidatedPhoto[]> = new EventEmitter<ValidatedPhoto[]>();

    @Output() public photosAreUploading: EventEmitter<void> = new EventEmitter<void>();

    @Input()
    public isFileReaderApiAvailable: boolean;

    @Input()
    public isAgentPhoto: boolean;

    private _photoValidationPipeline: Subject<File[]> = new Subject<File[]>();

    public acceptedMimeTypesList: string[] = ACCEPTED_PHOTO_TYPES;

    // tslint:disable-next-line:constructor-params-format
    constructor(
        private _photoValidationService: PhotoValidationService,
        changeDetectorRef: ChangeDetectorRef,
        @Self() @Optional() control: NgControl
    ) {
        super(control, changeDetectorRef);
    }

    protected tgOnWrite(_value: never): void {
        // Not used
    }

    protected tgOnFormChange(_formState: ValidatedPhoto[]): void {
        // Not used
    }

    public ngOnInit() {
        super.ngOnInit();
        this.setUpPhotoValidationPipeline();
    }

    private setUpPhotoValidationPipeline(): void {
        this._photoValidationPipeline
            .pipe(
                takeUntil(this._destroyed$),
                this._photoValidationService.validatePhotoFiles(
                    this.acceptedMimeTypesList,
                    MAX_FILE_SIZE,
                    this.isAgentPhoto ? MIN_AGENT_PHOTO_DIMENSION : MIN_PHOTO_DIMENSION,
                    PHOTO_LOAD_TIMEOUT,
                    !!this.isAgentPhoto
                )
            )
            .subscribe((photoFiles) => this.onPhotoFilesValidated(photoFiles));
    }

    private onPhotoFilesValidated(photoFiles: ValidatedPhoto[]) {
        this.photosUploaded.emit(photoFiles);
    }

    public onFilesSelected(files: FileList): void {
        if (files.length === 0) {
            return;
        }

        this.photosAreUploading.emit();
        const fileArray = Array.from(files || []);
        this._photoValidationPipeline.next(fileArray);
    }
}
